import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import MenuView from 'jet-views/menu'; // Import MenuView component
import ToolView from 'jet-views/toolbar'; // Import ToolView component

/**
 * Class representing the Reports Machine Register View.
 * @extends JetView
 */
export default class ReportsMachineRegisterView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        return {
            type: 'wide', // Layout type
            cols: [
                {
                    localId: 'inner:layout', // Local identifier for the layout
                    type: 'wide', // Layout type
                    rows: [
                        {
                            view: 'tabbar', // Tab bar component
                            localId: 'tabbar', // Local identifier for the tab bar
                            height: 43, // Height of the tab bar
                            tabMinWidth: 190, // Minimum width of each tab
                            tabMoreWidth: 80, // Width of the "more" tab
                            moreTemplate: function () {
                                // Template for the "more" tab
                                return (
                                    "<div style='font-weight: bold;border-left: 1px solid #ebedf0;height: 30px;line-height: 2;padding-left: 5px;color: #263043;'>" +
                                    _('Ver más') + // Translated text for "more"
                                    '</div>'
                                );
                            },
                            options: [
                                // Options for the tab bar
                                {
                                    id: 'machine.reports.depositReport', // Identifier for deposit report
                                    value: _('Reporte de Depósitos'), // Translated label
                                },
                                {
                                    id: 'machine.reports.withdrawalRequests', // Identifier for withdrawal requests report
                                    value: _('Reporte de Retiros'), // Translated label
                                },
                                {
                                    id: 'machine.reports.flujoCaja', // Identifier for cash flow report
                                    value: _('Reporte Flujo de Caja'), // Translated label
                                },
                                {
                                    id: 'machine.reports.userAfilliatesReport', // Identifier for user affiliates report
                                    value: _('Reporte de Usuarios'), // Translated label
                                },
                                {
                                    id: 'machine.reports.betsReport', // Identifier for bets report
                                    value: _('Reporte de Apuestas'), // Translated label
                                },
                                {
                                    id: 'machine.reports.casinoGamesReport', // Identifier for casino games report
                                    value: _('Reporte de Casino'), // Translated label
                                },
                                {
                                    id: 'machine.reports.logReport', // Identifier for logs report
                                    value: _('Reporte de Logs'), // Translated label
                                },
                                {
                                    id: 'machine.reports.updatesReport', // Identifier for updates report
                                    value: _('Reporte de Actualizaciones'), // Translated label
                                },
                            ],
                        },
                        { $subview: true }, // Placeholder for subview
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use menu plugin with the tab bar
        this.on(
            this.app,
            'person:select',
            (
                person, // Event listener for person selection
            ) => this.setParam('user', person.id, true), // Set user parameter with selected person's ID
        );
    }
}

// FILE DOCUMENTED
